import React, { useEffect, useState } from "react";
import { TagProps } from "../../../typings/tag";
import { getTagsPool } from "../../../services/searchService";
import { ITag } from "../utils/interfaces";
import TagsList from "./TagsList";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { toggleTagSelection } from "../../../redux/searchUsers";

// interface TagsPoolSearchProps {
//   onSelectedTags: (selectedTags: TagProps[]) => void;
// }

const TagsPoolSearch = () => {
  const dispatch = useDispatch();
  const { tagsPool } = useSelector((state: RootState) => state.searchUsers);

  //TODO: Remove it after dev
  useEffect(() => {
    // console.log({ tagsPool });
    console.log("searchUsers.tagsPool: ", tagsPool);
  }, [tagsPool]);

  const handleTagToggle = (tagId: number) => {
    console.log(tagId);

    dispatch(toggleTagSelection(tagId));
  };

  return (
    <>
      <div className="search_form_plate">
        <label htmlFor="field-6" className="search_label interests">
          לפי תגיות
        </label>

        <ul role="list" className="interest_list people_search w-list-unstyled">
          {tagsPool?.map((tag) => (
            <li
              key={`tag-${tag.text}-${tag.value}`}
              className="interest_item people_search"
            >
              <button
                type="button"
                className={`interest_link search ${
                  tag.isSelected ? "in" : ""
                } w-inline-block`}
                onClick={() => handleTagToggle(tag.value)}
              >
                <img
                  src={`assets/images/${
                    tag.isSelected ? "ic_in_circle.svg" : "ic_plus_circle.svg"
                  }`}
                  loading="lazy"
                  alt=""
                  className="interest_icon search"
                />
                <div className="interest_txt">{tag.text}</div>
              </button>
            </li>
          ))}
        </ul>
      </div>
    </>
  );

  // return (
  //   <>
  //     <TagsList />
  //   </>
  // );
};

export default TagsPoolSearch;
